interface SubmissionAlertProps {
  message: string | null;
  onDismiss: () => void;
  hasValidationErrors: boolean;
}

export function SubmissionAlert({ message, onDismiss, hasValidationErrors }: SubmissionAlertProps) {
  if (!message || hasValidationErrors) {
    return null;
  }

  return (
    <div
      role="alert"
      aria-live="polite"
      className="rounded-md border border-destructive/30 bg-destructive/10 p-4 text-sm text-destructive"
    >
      <div className="flex items-start justify-between gap-3">
        <p className="flex-1">{message}</p>
        <button
          type="button"
          onClick={onDismiss}
          className="text-sm font-medium text-destructive underline underline-offset-2 transition hover:text-destructive/80"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
